import * as React from "react";
import { IconButton } from "@bolteu/kalep-react";
import { cx } from "../../utils/cx";
export function AccordionTableInlineActions({ actions, item }) {
    return (React.createElement("div", { className: cx("inline-flex items-center py-1 gap-2") }, actions.map((action) => {
        const key = typeof action.label === "function" ? action.label({ row: item, action }) : action.label;
        return typeof action.customInlineRenderer === "function" ? (React.createElement("span", { key: key }, action.customInlineRenderer({ row: item, action }))) : (React.createElement(AccordionTableInlineActionDefault, { key: key, row: item, action: action }));
    })));
}
function AccordionTableInlineActionDefault(props) {
    const { action } = props;
    const label = typeof action.label === "function" ? action.label(props) : action.label;
    const icon = typeof action.icon === "function" ? action.icon(props) : React.cloneElement(action.icon, { size: "sm" });
    const onClick = React.useCallback((event) => {
        var _a;
        if (props.isRowClickable) {
            event.stopPropagation();
        }
        (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, props);
    }, [action, props]);
    return React.createElement(IconButton, { size: "sm", variant: "secondary", "aria-label": label, icon: icon, onClick: onClick });
}
